var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("返回示例")]),_c('pre',{staticClass:"content"},[_vm._v(_vm._s(JSON.stringify(_vm.returnObj, null, 4)))])])}
var staticRenderFns = []

export { render, staticRenderFns }